import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  t,
  Select,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class StockAudit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_status: "",

      count: 42,
      page: 1,

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,

      // Form States (for Modal "นับสต็อกใหม่")
      form_audit_type: "นับสต็อกทั้งหมด",
      form_location: "ทุกตำแหน่ง",
      form_schedule_date: "",
      form_assignee: "WH Admin",
      form_note: "",

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary: {
        ongoing: 2,
        discrepancies: 15,
        accuracy: "98.5%",
        next_count: "15 Jan",
      },

      // -----------------------------------
      // Mock Data: Ongoing Counts (ตามรูป image_265adc.jpg)
      // -----------------------------------
      ongoing_audits: [
        {
          id: "ST-2025-0012", title: `${t("count_all")} - Warehouse A`, status: t("in_progress"), statusColor: "primary",
          total_items: 450, counted: 312, remaining: 138, progress: 69, start_date: "10/01/2025"
        },
        {
          id: "ST-2025-0013", title: `${t("cycle_count")} - Class A Items`, status: t("pending_review"), statusColor: "warning",
          total_items: 85, counted: 85, remaining: 0, progress: 100, finish_date: "11/01/2025", diff_items: 8
        }
      ],

      // -----------------------------------
      // Mock Data: Discrepancy Table
      // -----------------------------------
      data_diff: [
        { id: "PRT-001234", desc: "Compressor Motor 2HP", location: "WH-A / R1-S2", system_qty: 5, counted_qty: 3, diff: -2, impact: "-25,000" },
        { id: "PRT-003789", desc: "Bearing 6205-2RS", location: "WH-B / R1-S3", system_qty: 128, counted_qty: 132, diff: 4, impact: "+720" },
        { id: "PRT-005678", desc: "Contactor 3P 25A", location: "WH-B / R2-S2", system_qty: 18, counted_qty: 17, diff: -1, impact: "-1,850" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };
render() {
    const { 
      ongoing_audits, data_diff, summary, 
      modal_create, form_audit_type, form_location, form_schedule_date, form_assignee, form_note 
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
            <div className="mb-4">
              <h3 className="fw-bold mb-1 text-dark">{t("stock_audit")}</h3>
              <div className="text-secondary text-14">{t("stock_audit_desc")}</div>
            </div>

          {/* Top Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf46d"}</div>
                  <div><h3 className="fw-bold text-dark mb-0">{summary.ongoing}</h3><div className="text-secondary text-12 fw-bold">{t("ongoing_count")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf071"}</div>
                  <div><h3 className="fw-bold text-warning mb-0">{summary.discrepancies}</h3><div className="text-secondary text-12 fw-bold">{t("discrepancies")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                  <div><h3 className="fw-bold text-success mb-0">{summary.accuracy}</h3><div className="text-secondary text-12 fw-bold">{t("accuracy_rate")}</div></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf073"}</div>
                  <div><h3 className="fw-bold text-dark mb-0">{summary.next_count}</h3><div className="text-secondary text-12 fw-bold">{t("next_count")}</div></div>
                </div>
              </div>
            </div>
          </div>

          {/* Section: Ongoing Audits */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                <span className="icon text-primary me-2">{"\uf2f1"}</span> {t("ongoing_audits_title")}
              </h6>
              <button 
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                onClick={() => this.setState({ modal_create: true })}
              >
                <span className="me-2 text-16">+</span> {t("new_stock_count")}
              </button>
            </div>

            <div className="row g-4">
              {ongoing_audits.map((item, idx) => (
                <div key={idx} className="col-lg-6">
                  <div className="border rounded-4 p-4 position-relative overflow-hidden bg-white shadow-sm">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <div className="fw-bold text-dark text-16 mb-1">{item.id}</div>
                        <div className="text-secondary text-14">{item.title}</div>
                      </div>
                      <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${item.statusColor}`}>
                        {item.status}
                      </span>
                    </div>

                    <div className="row text-center bg-light rounded-3 p-3 mb-3 mx-0">
                      <div className="col-4 border-end">
                        <h4 className="fw-bold text-dark mb-0">{item.total_items}</h4>
                        <div className="text-secondary text-10">{t("total_items")}</div>
                      </div>
                      <div className="col-4 border-end">
                        <h4 className="fw-bold text-success mb-0">{item.counted}</h4>
                        <div className="text-secondary text-10">{t("counted")}</div>
                      </div>
                      <div className="col-4">
                        <h4 className={`fw-bold mb-0 ${item.remaining > 0 ? 'text-warning' : 'text-danger'}`}>
                          {item.remaining > 0 ? item.remaining : item.diff_items}
                        </h4>
                        <div className="text-secondary text-10">{item.remaining > 0 ? t("remaining") : t("diff")}</div>
                      </div>
                    </div>

                    <div className="progress hpx-8 mb-3 rounded-pill bg-light">
                      <div className={`progress-bar bg-${item.statusColor === 'primary' ? 'primary' : 'success'}`} style={{ width: `${item.progress}%` }}></div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-secondary text-12">
                        {item.start_date ? `${t("started_prefix")}${item.start_date}` : `${t("finished_prefix")}${item.finish_date}`}
                      </div>
                      <div className="d-flex gap-2">
                        {item.progress === 100 ? (
                           <>
                             <button className="btn btn-white border btn-sm icon text-dark shadow-none">{"\uf06e"}</button>
                             <button className="btn btn-success btn-sm fw-bold px-3 border-0">{"\uf00c"} {t("approve")}</button>
                           </>
                        ) : (
                          <>
                            <button className="btn btn-white border btn-sm fw-bold text-dark shadow-none d-flex align-items-center"><span className="icon me-1">{"\uf02f"}</span> {t("print_form")}</button>
                            <button className="btn btn-primary btn-sm fw-bold px-3 border-0">{"\uf04b"} {t("continue_action")}</button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Section: Discrepancy Report */}
          <div className="bg-white rounded-4 shadow-sm p-0 overflow-hidden">
            <div className="p-4 border-bottom d-flex justify-content-between align-items-center">
              <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                <span className="icon text-warning me-2">{"\uf24e"}</span> {t("discrepancy_report")} - ST-2025-0013
              </h6>
              <div className="d-flex gap-2">
                <button className="btn btn-white border btn-sm fw-bold text-dark d-flex align-items-center"><span className="icon me-2">{"\uf019"}</span> {t("export")}</button>
                <button className="btn btn-success btn-sm fw-bold px-3 d-flex align-items-center border-0" style={{ backgroundColor: '#22c55e' }}><span className="icon me-2">{"\uf00c"}</span> {t("approve_all")}</button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-4 border-0 wpx-150">{t("part_code")}</th>
                    <th className="py-3 border-0">{t("description")}</th>
                    <th className="py-3 border-0 wpx-150">{t("location")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("system_qty")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("counted_qty")}</th>
                    <th className="py-3 border-0 text-center wpx-100">{t("diff")}</th>
                    <th className="py-3 border-0 text-center wpx-150">{t("value_impact")}</th>
                    <th className="py-3 border-0 wpx-150">{t("reason")}</th>
                    <th className="py-3 border-0 text-center wpx-120">{t("manage")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data_diff.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-3 px-4 fw-bold text-primary font-monospace">{item.id}</td>
                      <td className="text-dark text-14">{item.desc}</td>
                      <td className="text-secondary text-14">{item.location}</td>
                      <td className="text-center fw-bold text-dark">{item.system_qty}</td>
                      <td className="text-center fw-bold text-dark">{item.counted_qty}</td>
                      <td className={`text-center fw-bold ${item.diff < 0 ? 'text-danger' : 'text-success'}`}>{item.diff > 0 ? `+${item.diff}` : item.diff}</td>
                      <td className={`text-center fw-bold ${item.diff < 0 ? 'text-danger' : 'text-success'}`}>{item.impact}</td>
                      <td>
                        <Select
                            className="form-control form-select-sm border-light shadow-none bg-light text-secondary"
                            options={[{ value: "", label: t("select_placeholder") }]}
                            value=""
                            onChange={() => {}}
                            placeholder={t("select_placeholder")}
                            default={false}
                        />
                      </td>
                      <td className="text-center">
                        <button className="btn btn-primary btn-sm px-3 rounded-2 border-0">{t("adjust")}</button>
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-light border-top-0">
                    <td colSpan="6" className="text-end py-3 fw-bold text-dark">{t("total")}</td>
                    <td className="text-center py-3 fw-bold text-danger">-26,130</td>
                    <td colSpan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        {/* MODAL: นับสต็อกใหม่ */}
        <Modal size="md" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
          <Modal.Header className="bg-white border-bottom-0 pb-0 pt-4 px-4" closeButton>
            <h4 className="fw-bold mb-0 text-dark">{t("new_stock_count")}</h4>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            <div className="d-flex flex-column gap-3">
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("audit_type")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control py-2"
                  options={[
                    { value: "นับสต็อกทั้งหมด", label: t("count_all") },
                    { value: "นับรอบ (Cycle Count)", label: t("cycle_count") },
                    { value: "นับเฉพาะจุด", label: t("spot_count") },
                  ]}
                  value={form_audit_type}
                  onChange={(e) => this.setState({ form_audit_type: e })}
                  placeholder={t("count_all")}
                  default={false}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("location")}</label>
                <Select
                  className="form-control py-2"
                  options={[
                    { value: "ทุกตำแหน่ง", label: t("all_locations") },
                    { value: "WH-A", label: "WH-A" },
                    { value: "WH-B", label: "WH-B" },
                  ]}
                  value={form_location}
                  onChange={(e) => this.setState({ form_location: e })}
                  placeholder={t("all_locations")}
                  default={false}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("scheduled_date")}</label>
                <div className="position-relative">
                  <input type="text" className="form-control py-2" placeholder={t("date_placeholder")} />
                  <span className="icon position-absolute top-50 end-0 translate-middle-y me-3 text-secondary">{"\uf073"}</span>
                </div>
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("assign_to")}</label>
                <Select
                  className="form-control py-2"
                  options={[
                    { value: "WH Admin", label: "WH Admin" },
                    { value: "Somchai", label: "Somchai" },
                  ]}
                  value={form_assignee}
                  onChange={(e) => this.setState({ form_assignee: e })}
                  placeholder="WH Admin"
                  default={false}
                />
              </div>
              <div>
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("note")}</label>
                <textarea className="form-control py-2" rows="3" placeholder={t("note")} value={form_note} onChange={(e) => this.setState({ form_note: e.target.value })}></textarea>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_create: false })}>{t("cancel")}</button>
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm d-flex align-items-center">
              <span className="icon me-2">{"\uf15c"}</span> {t("create_and_print_form")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}